import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, OBJECT } from '@/plugins/sdk/fields'
import Request, { POST } from '@/plugins/sdk/Request'

export default class extends Resource {
  static name = 'customeriolog'

  static get fields () {
    return {
      id: new UUID(),
      resource: new STRING(),
      resource_uuid: new UUID(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      event_name: new STRING(),
      response_status: new STRING(),
      response_body: new STRING(),
      body: new OBJECT()
    }
  }

  static async resend (id) {
    const request = await (Object.assign(new Request(), {
      method: POST,
      _pathname: 'notification/resend',
      body: {
        id: id,
        type: 'customer_io'
      }
    })).build()

    const response = await fetch(request)

    if (response.ok) {
      const data = await response.json()
      if (data.success) {
        this.$message.success('Notification resent successfully.')
        return true
      } else {
        this.$message.error('Failed to resend notification.')
        return false
      }
    } else {
      this.$message.error('Failed to resend notification.')
      return false
    }
  }
}
